import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useCanRenouncePreferences } from 'hooks/useCanRenouncePreferences';

import './styles.scss';

type RegulamentoLayoutProps = {
  title: string;
  children: ReactNode;
};

const TAB_BASE =
  'jj-tab block text-center rounded-xl shadow-[0_1px_2px_rgba(21,21,24,.08),0_1px_3px_rgba(25,25,28,.12)] px-3.5 py-[15px] font-display font-bold text-sm no-underline';

const TAB_IDLE = `${TAB_BASE} bg-brand-white`;

const TAB_ACTIVE = `${TAB_BASE} jj-tab--ativo bg-brand-blue`;

export default function RegulamentoLayout({ title, children }: RegulamentoLayoutProps) {
  const { pathname } = useLocation();
  const canRenouncePreferences = useCanRenouncePreferences();

  const tabs = [
    { label: 'Regras', to: '/regulamento' },
    { label: 'Dúvidas frequentes', to: '/ajuda' },
    canRenouncePreferences && { label: 'Minhas preferências', to: '/minhas-preferencias' },
    { label: 'Nosso manifesto', to: '/manifesto' },
  ].filter(Boolean) as { label: string; to: string }[];

  return (
    <div className="mx-auto w-full max-w-[1000px] px-6 pb-10 pt-4 lg:px-0 lg:pt-0">
      <div className="mb-[22px] flex items-center gap-3.5">
        <Link
          to="/"
          aria-label="Voltar para a página inicial"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--brand-yellow)"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </Link>

        <h1 className="m-0 font-display text-[28px] font-extrabold text-brand-blue-dark">{title}</h1>
      </div>

      <nav aria-label="Seções do regulamento" className="mb-5 grid grid-cols-2 gap-2.5 lg:grid-cols-4">
        {tabs.map(tab => {
          const active = pathname === tab.to;

          return (
            <Link key={tab.to} to={tab.to} aria-current={active ? 'page' : undefined} className={active ? TAB_ACTIVE : TAB_IDLE}>
              {tab.label}
            </Link>
          );
        })}
      </nav>

      <div className="jj-rise">{children}</div>
    </div>
  );
}
